var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 0C0.940201 0 0 0.940203 0 2.1V21.9C0 23.0598 0.940203 24 2.1 24H21.9C23.0598 24 24 23.0598 24 21.9V2.1C24 0.940201 23.0598 0 21.9 0H2.1ZM1.8 2.1C1.8 1.93431 1.93432 1.8 2.1 1.8H21.9C22.0657 1.8 22.2 1.93432 22.2 2.1V21.9C22.2 22.0657 22.0657 22.2 21.9 22.2H2.1C1.93431 22.2 1.8 22.0657 1.8 21.9V2.1Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.0602C6 11.5631 6.40294 11.1602 6.9 11.1602H17.1C17.5971 11.1602 18 11.5631 18 12.0602C18 12.5572 17.5971 12.9602 17.1 12.9602H6.9C6.40294 12.9602 6 12.5572 6 12.0602Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxMinus);
export default __webpack_public_path__ + "static/media/checkbox-minus.5b743ae5.svg";
export { ForwardRef as ReactComponent };